<div class="layout-content" id="stepDialog">
	<form (ngSubmit)="submit()" [formGroup]="stepNameForm">
		<div class="grid mb-6">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText
							[ngClass]="dynamicInputTextWidth()"
							id="scenery-add-input-name"
							formControlName="name"
							autocomplete="scenery-name"
							placeholder="{{ 'NAME' | translate }}"
							maxlength="64"
						/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<p-stepper [(activeStep)]="activeIndex">
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
							[class]="getColorFirstTab()"
					>
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-devices text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'DEVICE' | translate }}</label>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div class="grid">
						<div class="col-12" [class]="onExtendedMobile() ? '' : 'pb-8'" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap" [ngClass]="showErrorsWithTabValidation(this.f.device, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsWithTabValidation(this.f.device, 'label')">{{ 'SELECT_DEVICE' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsWithTabValidation(this.f.device, 'borderInput')">
									<p-autoComplete formControlName="device" [suggestions]="filteredDevices"
										[ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }}"
										inputStyleClass="flex align-items-center justify-content-center text-center pl-5 border-noround-right"
										id="step-input-device" appendTo="body"
										(onSelect)="onSelectDevice($event)"
										(completeMethod)="filterDevice($event)" field="Name" [dropdown]="true"
										[forceSelection]="true">
										<ng-template let-device pTemplate="item">
											<div class="flex justify-content-center">
												{{ device.Name }}
											</div>
										</ng-template>
									</p-autoComplete>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.device)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
					</div>

					<div class="flex py-3 justify-content-end">
						<!-- [disabled]="!canSwitchTab()" -->
						<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary" (onClick)="changeActiveTabClick(1)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(1)"
						[class]="getColorSecondTab()"
					>
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-scenery-type-action text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'ACTION_TYPE' | translate }}</label>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div class="grid">
						<div class="col-12" [class]="onExtendedMobile() ? '' : 'pb-8'" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap" [ngClass]="showErrorsWithTabValidation(this.f.actionType, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsWithTabValidation(this.f.actionType, 'label')">{{ 'SELECT_ACTION_TYPE' | translate }} </div>
								<div class="flex align-items-center justify-content-center" [ngClass]="showErrorsWithTabValidation(this.f.actionType, 'borderInput')">
									<p-dropdown [options]="actionTypes"
										[ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }} flex align-items-center justify-content-center text-center pl-5"
										id="step-input-actionType"
										formControlName="actionType" (onChange)="onSelectTypeAction($event)">
										<ng-template pTemplate="selectedItem">
											<div class="item">
												<div>{{ (f.actionType.value ) ? (f.actionType.value.Name | translate) : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-actionType pTemplate="item">
											<div class="item">
												<div>{{actionType.Name | translate }}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.actionType)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
					</div>

					<div class="flex py-3 justify-content-between">
						<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" iconPos="left" severity="secondary" (onClick)="changeActiveTabClick(0)" />
						<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary" (onClick)="changeActiveTabClick(2)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(2)"
						[class]="getColorThirdTab()"
					>
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-scenery-action text-2xl pr-2"></i>
							<p *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'ACTION' | translate }}</p>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div class="grid">
						<div *ngIf="f.actionType.value.Id === 1" class="col-12" [class]="onExtendedMobile() ? '' : 'pb-8'" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.command, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.command, 'label')">{{ 'SELECT_ACTION' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.command, 'borderInput')">
									<p-dropdown [options]="commands"
										[ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center"
										id="step-input-device" appendTo="body"
										formControlName="command">
										<ng-template *ngIf="f.device.value" pTemplate="header">
											<div class="col-12 pb-0 pr-5 flex justify-content-center font-semibold">{{ f.device.value.Name }}</div>
										</ng-template>
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center">
												{{ (f.command.value ) ?
													getAutomationName(f.command.value) + getOutputName(f.command.value) + f.command.value.Description
													: ""
												}}
											</div>
										</ng-template>
										<ng-template let-command pTemplate="item">
											<div class="item flex justify-content-center gap-1">
												<div class="font-semibold">{{ getAutomationName(command)}}</div>
												<div>{{ getOutputName(command) }} {{ command.Description }}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
						</div>
						<div *ngIf="f.actionType.value.Id === 2" class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.delayTime, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.delayTime, 'label')">{{ 'DEFINE_DELAY_TIME' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.delayTime, 'borderInput')">
									<p-inputNumber formControlName="delayTime" inputId="minmax-buttons" step="1" [useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true" [min]="0"
										incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
										inputStyleClass="border-noround-right pl-6"
										[ngClass]="dynamicInputTextWidth()"
										[styleClass]="dynamicInputTextWidth()">
									</p-inputNumber>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessageMultiOptions(this.f.delayTime)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<div *ngIf="f.actionType.value.Id === 2" class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.delayUnit, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.delayUnit, 'label')">{{ 'TIME_UNIT' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.delayUnit, 'borderInput')">
									<p-dropdown [options]="timeUnits"
										[ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }} flex align-items-center justify-content-center text-center pl-5"
										id="step-input-delayUnit"
										formControlName="delayUnit">
										<ng-template pTemplate="selectedItem">
											<div class="item">
												<div>{{ (f.delayUnit.value ) ? f.delayUnit.value.Label : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-unit pTemplate="item">
											<div class="item">
												<div>{{unit.Label}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
						</div>
						<div *ngIf="f.actionType.value.Id === 3" class="col-12" [class]="onExtendedMobile() ? 'px-0' : 'pb-5 mb-8'" [ngClass]="customPaddingX()">
							<p-accordion>
								<p-accordionTab *ngFor="let settingCategory of settings; let i=index;">
									<ng-template pTemplate="header">
										<span class="flex align-items-center gap-2 w-full">
											<span class="font-bold white-space-nowrap">{{ settingCategory.Description }}</span>
										</span>
									</ng-template>
										<div class="grid mt-1">
											<div class="col-12 ml-2 flex align-items-center justify-content-start" *ngFor="let sett of settingCategory.Settings; let i=index;" [ngClass]="customPaddingX()">
												<p-radioButton [value]="sett.Id" formControlName="settingId" [id]="sett.Id"
																	class="p-radiobutton-policy mr-2"
																	(onClick)="onSelectRadioButton($event)">
												</p-radioButton>
												<label [for]="sett.Id">{{ sett.Description }}</label>
											</div>
											<div class="col-12" [ngClass]="customPaddingX()">
												<div *ngIf="controlItem.Type !== '' && settingOwner(settingCategory.Settings, this.f.settingId)">
													<div *ngIf="controlItem.Type === 'slider'" class="grid">
														<div class="col-2 flex align-items-center justify-content-end">
															<p-button pTooltip="{{ 'DECREASE' | translate }}"
																[disabled]="f.settingValue.value <= getSliderScaledMin()"
																tooltipPosition="bottom" icon="pi cm-minus" size="large"
																(click)="setSliderValue(f.settingValue, -1)" [rounded]="false" [text]="true" severity="primary"
																class="pr-3">
															</p-button>
															<span>{{formattedSliderMin()}}</span>
														</div>
														<div class="col-8">
															<p-inputNumber mode="decimal"  [useGrouping]="false"
																	formControlName="settingValue"
																	class="flex w-full"
																	styleClass="flex w-full"
																	(onBlur)="onChangeInputSlider(f.settingValue)"
																	[min]="getSliderScaledMin()"
																	[max]="getSliderScaledMax()">
															</p-inputNumber>
															<p-slider formControlName="settingValue" class="w-full" [step]="getSliderScaledStep()"
																		(onChange)="onChangeSlider(f.settingValue)"
																		[min]="getSliderScaledMin()"
																		[max]="getSliderScaledMax()">
															</p-slider>
														</div>
														<div class="col-2 flex align-items-center justify-content-start">
															<span>{{formattedSliderMax()}}</span>
															<p-button pTooltip="{{ 'INCREASE' | translate}}"
																	[disabled]="f.settingValue.value >= getSliderScaledMax()"
																	tooltipPosition="bottom" icon="pi cm-plus" size="large"
																	(click)="setSliderValue(f.settingValue, 1)" [rounded]="false" [text]="true" severity="primary"
																	class="pl-3">
															</p-button>
														</div>
													</div>

													<div *ngIf="controlItem.Type === 'numeric'">
														<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.settingValue, 'borderRow')">
															<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.settingValue, 'borderInput')">
																<p-inputNumber formControlName="settingValue" inputId="minmax-settingsValue" step="1" [useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true"
																		incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
																		[ngClass]="dynamicInputTextWidth()"
																		[styleClass]="dynamicInputTextWidth()" [min]="controlItem.Min" [max]="controlItem.Max">
																</p-inputNumber>
															</div>
														</div>
														<small *ngIf="showErrorRequiredMessageMultiOptions(this.f.settingValue)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
													</div>

													<div *ngIf="controlItem.Type === 'combo'">
														<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
															<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ 'SELECT' | translate }}</div>
															<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
																<p-dropdown [options]="controlItem.Items"
																	[ngClass]="dynamicInputTextWidth()"
																	styleClass="{{ dynamicInputTextWidth() }} align-items-center"
																	id="radio-input-settingValue"
																	formControlName="settingValue">
																	<ng-template pTemplate="selectedItem">
																		<div class="item" class="flex align-items-center">
																			<div class="flex align-items-center">{{ (f.settingValue.value ) ? f.settingValue.value.Description : "" }}</div>
																		</div>
																	</ng-template>
																	<ng-template let-sett pTemplate="item">
																		<div class="item">
																			<div>{{sett.Description}}</div>
																		</div>
																	</ng-template>
																</p-dropdown>
															</div>
														</div>
														<small *ngIf="showErrorRequiredMessageMultiOptions(this.f.settingValue)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
													</div>
													<div *ngIf="controlItem.Type === 'color_picker'">
														<!-- <div class="flex justify-content-center flex-wrap border-bottom-1 border-100">
															<div class="flex align-items-center justify-content-center" [class]="dynamicInputTextWidth()"> -->
														<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
															<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ 'SELECT_COLOR' | translate }}</div>
															<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
																<p-dropdown [options]="controlItem.Items"
																	[ngClass]="dynamicInputTextWidth()"
																	styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center pl-5"
																	formControlName="settingValue">
																	<ng-template pTemplate="selectedItem">
																		<div class="flex align-items-center justify-content-center">
																			<div class="w-1_5rem h-1_5rem flex-shrink-0 border-circle cursor-pointer surface-border transition-all transition-duration-300 mr-3"
																				style="border: 1px solid;"
																				[ngStyle]="{'color': getColorSettingValue(f.settingValue.value), 'background-color': getColorSettingValue(f.settingValue.value)}"
																			>
																			</div>
																			<div>{{ (f.settingValue.value ) ? f.settingValue.value.Description : "" }}</div>
																		</div>
																	</ng-template>
																	<ng-template let-sett pTemplate="item">
																		<div class="item flex align-items-center justify-content-center">
																			<div class="w-1_5rem h-1_5rem flex-shrink-0 border-circle cursor-pointer surface-border transition-all transition-duration-300 mr-3"
																				style="border: 1px solid;"
																				[ngStyle]="{'color': getColorSettingValue(sett), 'background-color': getColorSettingValue(sett)}"
																			>
																			</div>
																			<div>{{ sett.Description }}</div>
																		</div>
																	</ng-template>
																</p-dropdown>
															</div>
														</div>
														<small *ngIf="showErrorRequiredMessageMultiOptions(this.f.settingValue)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
													</div>
												</div>
											</div>
										</div>
								</p-accordionTab>
							</p-accordion>
						</div>
					</div>

					<div class="flex py-3 justify-content-start">
						<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" severity="secondary" (onClick)="changeActiveTabClick(1)" />
					</div>
				</ng-template>
			</p-stepperPanel>

			<ng-template pTemplate="end">
				<div class="grid mt-2 mb-1 mx-1 flex justify-content-center align-items-center">
					<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple
						label="{{ 'CONFIRM' | translate }}"
						class="p-button-primary text-xl font-normal mx-1 mb-2"
						[ngClass]="dynamicButtonWidth()">
					</button>
					<button type="button" pButton pRipple (click)="closeDialog()"
							label="{{ 'CLOSE' | translate }}"
							class="p-button-secondary text-xl font-normal mx-1 mb-2"
							[ngClass]="dynamicButtonWidth()">
					</button>
				</div>
			</ng-template>

		</p-stepper>
	</form>
</div>
